import { styled, kfrm, css, xStyledCommonProps } from '@elliemae/ds-legacy-system';
import type { SpaceProps, SizingProps, LayoutProps } from '@elliemae/ds-legacy-system';
import {} from '@xstyled/system';

interface StyledContentWrapperPropsT {
  zIndex: number;
}

interface StyledAnimatedPopperPropsT {
  showPopover: boolean;
  animationDuration: number;
  withoutAnimation: boolean;
}

const showAnimation = kfrm`
    from {
      opacity: 0;
      transform: scale(0.8);
    }

    to {
      opacity: 1;
      transform: scale(1);
      visibility: visible;
    }
`;

const hideAnimation = kfrm`
    from {
      opacity: 1;
      transform: scale(1);
    }

    to {
      opacity: 0;
      transform: scale(0.8);
      visibility: hidden;
    }
`;

export const StyledPopoverContentWrapper = styled('div')<
  StyledContentWrapperPropsT & Omit<LayoutProps, 'zIndex'> & SpaceProps & SizingProps
>`
  z-index: ${({ theme, zIndex }) => zIndex ?? theme.zIndex.popper};
  ${xStyledCommonProps}
`;

export const StyledAnimatedPopper = styled.div<StyledAnimatedPopperPropsT>`
  box-shadow:
    0 0 0 1px rgba(16, 22, 26, 0.1),
    0 2px 4px rgba(16, 22, 26, 0.2),
    0 8px 24px rgba(16, 22, 26, 0.2);

  ${({ showPopover, animationDuration, withoutAnimation }) =>
    !withoutAnimation &&
    css`
      animation: ${showPopover ? showAnimation : hideAnimation} ${animationDuration}ms ease-in;
    `}
`;
